export default {
    state: 'Departamento / Estado',
    statePlaceHolder: 'Selecciona un departamento',
    noState: 'Departamento no encontrado',
    noStates: 'Departamentos no encontrados',
};
